import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertService } from '../../../core/alerts/alert.service';
import { IndexCard } from '../../../auth/store/models';

@Component({
    selector: 'app-statistik-ydelse-options',
    templateUrl: './statistik-ydelse-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikYdelseOptionsComponent {
    @Input() laCards: IndexCard[];
    @Input() kaCards: IndexCard[];
    @Input() saCards: IndexCard[];
    @Input() periode: {fra: string, til: string};
    @Input() laID: number;
    @Input() kaID: number;
    @Input() saID: number;
    @Output() periodeChange = new EventEmitter<{fra: string, til: string}>();
    @Output() selectLedelseAnsvarlig = new EventEmitter<number>();
    @Output() selectKundeAnsvarlig = new EventEmitter<number>();
    @Output() selectSagsAnsvarlig = new EventEmitter<number>();


    @Output() selectHourFormat = new EventEmitter<string>();
    format = 'Timer';
    @Output() exportExcel = new EventEmitter();

    constructor(
        private alert: AlertService,
    ) { }

    onFraChange(fra: string, isValidDate: boolean) {
        if (!isValidDate || !fra) { return; }
        if (!this.isValidPeriode(fra, this.periode.til)) { return; }
        this.periode.fra = fra;
        this.onPeriodeChange();
    }

    onTilChange(til: string, isValidDate: boolean) {
        if (!isValidDate || !til) { return; }
        if (!this.isValidPeriode(this.periode.fra, til)) { return; }
        this.periode.til = til;
        this.onPeriodeChange();
    }

    onSelectKundeAnsvarlig(id: number) {
        this.selectKundeAnsvarlig.emit(id);
    }
    onSelectLedelseAnsvarlig(id: number) {
        this.selectLedelseAnsvarlig.emit(id);
    }
    onSelectSagsAnsvarlig(id: number) {
        this.selectSagsAnsvarlig.emit(id);
    }
    onselectFormat(format: string) {
        this.format = format;
        this.selectHourFormat.emit(format);
    }
    findLaName(id: number): string {
        let name = '';
        if (this.laCards) {
            for (const c of this.laCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }
    findKaName(id: number): string {
        let name = '';
        if (this.kaCards) {
            for (const c of this.kaCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }
    findSaName(id: number): string {
        let name = '';
        if (this.saCards) {
            for (const c of this.saCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }
    private isValidPeriode(fra: string, til: string) {
        if (new Date(fra) > new Date(til)) {
            this.alert.createAlert(
                'Til dato skal være større end fra dato!',
                'danger'
            );
            return false;
        }
        return true;
    }

    private onPeriodeChange() {
        if (!this.periode.fra || !this.periode.til) { return; }
        this.periodeChange.emit({fra: this.periode.fra, til: this.periode.til});
    }

    onExportExcel() {
        this.exportExcel.emit();
    }
}
